import React, { useContex,useEffect,useContext } from "react";
import img_1 from "../../../images/logo_consent.png";
import img_2 from "../../../images/logo_consentMobile.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material";

import "./components.css";
import TransferContext, { TransferProvider } from "../TranferContextProvider.js";
import {
  insertActivityLog,
} from "../../Home/homeService/homeService.js";
import CryptoJS from "crypto-js";

const RegisterQuickTransfet = () => {
  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const { activeStep, setActiveStep, skipped, setSkipped } =
    useContext(TransferContext);

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };


  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleSubmitLog = async (type) => {
    const citizen = localStorage.getItem("customer_id");

    if (!citizen) {
      console.error("No encrypted citizen ID found in localStorage.");
      return;
    }

    const decrypted = decryptCardNumber(citizen, process.env.REACT_APP_ENCRYPT_DATA); // ตรวจสอบว่า secretKey ถูกต้องหรือไม่
    const activityMap = {
      citizenID: decrypted,
      activityType: type
    };
    await insertActivityLog(activityMap);

  };

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  useEffect(() => {
    handleSubmitLog("รายชื่อลงทะเบียน Rabbit Pay")
  }, );

  return (
    <>
      <div className="middle-item">
        {/* <img src={img_1} height="120" alt="" /> */}
        <div>
          <img src={img_1} height={isSmallScreen ? "120" : "160"} alt="" />
        </div>
        {/* <div
          style={{
            display: isSmallScreen ? "block" : "none",
          }}
        >
          <img src={img_2} height="120" alt="" />
        </div> */}
        <div
          style={{
            flex: 1,
            flexDirection: "column",
            marginTop: 40,
            justifyContent: "start",
            width: "100%",
          }}
        >
          <span>บริการโอนเงินตามกรมธรรม์ผ่านบัญชีธนาคาร</span>
          <div>
            <span style={{ marginLeft: 10 }}>- สะดวก รวดเร็ว ปลอดภัย</span>
          </div>
          <div>
            <span style={{ marginLeft: 10 }}>
              - ไม่ต้องรอเช็ค ไม่ต้องเดินทางนำเช็คไปขึ้น
            </span>
          </div>
          <div>
            <span style={{ marginLeft: 10 }}>- ไม่มีค่าธรรมเนียมการโอน</span>
          </div>
        </div>
        <button
          style={{ fontSize: 15 }}
          onClick={handleNext}
          className="btn-checkout-premium w-100 p-2 bold"
        >
          สมัครเลย
        </button>
      </div>
    </>
  );
};

export default RegisterQuickTransfet;
